// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SegmentedButtonGroup_group__qKShi {
    display: inline-flex;
}

.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_small__rWvHp button {
    padding: var(--sizing-spacing-x-small) var(--sizing-spacing-smedium) var(--sizing-spacing-x-small) var(--sizing-spacing-smedium);
    font-size: 12px;
    line-height: 20px;
}


.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_large__J7Mw0 button {
    padding: var(--sizing-spacing-small) var(--sizing-spacing-medium) var(--sizing-spacing-small) var(--sizing-spacing-medium);
    font-size: 14px;
    line-height: 21px;
}

.SegmentedButtonGroup_group__qKShi button:first-child { border-radius: var(--sizing-spacing-x-small) 0 0 var(--sizing-spacing-x-small); }
.SegmentedButtonGroup_group__qKShi button:last-child  { border-radius: 0 var(--sizing-spacing-x-small) var(--sizing-spacing-x-small) 0 }

.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_large__J7Mw0 [class*="segmentedButton"] [class*="icon-"],
.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_large__J7Mw0 [class*="segmentedButton"] [class^="icon-"] {
    font-size: 20px;
}

.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_large__J7Mw0 [class*="segmentedButton"] svg {
    display: flex;
    align-items: center;
    height: 20px;
    width: 20px;
}

.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_small__rWvHp [class*="segmentedButton"] [class*="icon-"],
.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_small__rWvHp [class*="segmentedButton"] [class^="icon-"] {
    font-size: 16px;
}

.SegmentedButtonGroup_group__qKShi.SegmentedButtonGroup_small__rWvHp [class*="segmentedButton"] svg {
    display: flex;
    align-items: center;
    height: 16px;
    width: 16px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/SegmentedButton/SegmentedButtonGroup.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,gIAAgI;IAChI,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,0HAA0H;IAC1H,eAAe;IACf,iBAAiB;AACrB;;AAEA,wDAA4B,8EAA8E,EAAE;AAC5G,wDAA4B,+EAA+E;;AAE3G;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf","sourcesContent":[".group {\n    display: inline-flex;\n}\n\n.group.small button {\n    padding: var(--sizing-spacing-x-small) var(--sizing-spacing-smedium) var(--sizing-spacing-x-small) var(--sizing-spacing-smedium);\n    font-size: 12px;\n    line-height: 20px;\n}\n\n\n.group.large button {\n    padding: var(--sizing-spacing-small) var(--sizing-spacing-medium) var(--sizing-spacing-small) var(--sizing-spacing-medium);\n    font-size: 14px;\n    line-height: 21px;\n}\n\n.group button:first-child { border-radius: var(--sizing-spacing-x-small) 0 0 var(--sizing-spacing-x-small); }\n.group button:last-child  { border-radius: 0 var(--sizing-spacing-x-small) var(--sizing-spacing-x-small) 0 }\n\n.group.large [class*=\"segmentedButton\"] [class*=\"icon-\"],\n.group.large [class*=\"segmentedButton\"] [class^=\"icon-\"] {\n    font-size: 20px;\n}\n\n.group.large [class*=\"segmentedButton\"] svg {\n    display: flex;\n    align-items: center;\n    height: 20px;\n    width: 20px;\n}\n\n.group.small [class*=\"segmentedButton\"] [class*=\"icon-\"],\n.group.small [class*=\"segmentedButton\"] [class^=\"icon-\"] {\n    font-size: 16px;\n}\n\n.group.small [class*=\"segmentedButton\"] svg {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    width: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `SegmentedButtonGroup_group__qKShi`,
	"small": `SegmentedButtonGroup_small__rWvHp`,
	"large": `SegmentedButtonGroup_large__J7Mw0`
};
export default ___CSS_LOADER_EXPORT___;
